export interface WoundConsultation {
  patientId: string | null;
  patientName: string | null;

  consultations: Consultations[];
}

export interface AssignedDoctor {
  id: string;
  doctorId: string;
  doctorName: string;
}

export interface Consultations {
  nurseId: string | null;
  nurseName: string | null;

  doctorId: string | null;
  doctorName: string | null;

  id: string | null;

  managerId: string | null;
  managerName: string | null;

  status: ConsultationStatus;
  assignDoctors: AssignedDoctor[];

  patientId: string | null;
}

export enum ConsultationStatus {
  Created = 0,
  Answered = 1,
  Closed = 2,
}

export interface WoundConsultationListItem {
  id: string | null;
  name: string | null;
  PatientID: string | null;
  nurseName: string | null;
  doctorName: string | null;
  managerName: string | null;
  consultationStatus: string;
  assignedToMe: boolean;
  consultationStatusRaw: string;
  hasWound: boolean;
  patientOrganizationId?: string;
  woundStatus?: number;
  woundConsultationAssignDoctors?: WoundConsultationAssignDoctor[];
}

export interface WoundConsultationDetail {
  id: string;

  patientId: string;
  patientName: string;

  nurseId: string;
  nurseName: string;

  doctorId?: string | null;
  doctorName?: string | null;

  managerId?: string | null;
  managerName?: string | null;

  message?: string | null;
  note?: string | null;
  hasWound?: boolean | null;

  status: ConsultationStatus;

  assignDoctors?: WoundConsultationAssignDoctor[];
  images?: WoundConsultationImage[];
}

export interface WoundConsultationAssignDoctor {
  id: string;
  doctorId: string;
  doctorName: string;
}

export interface WoundConsultationImage {
  id: string;
  fileName: string;
  filePath: string;
  base64: string;
}
